import { toIcons } from "../../consts/Paths";
import useIsMobile from "../../hooks/useIsMobile";
import useToggle from "../../hooks/useToggle";
import { AccordionProps } from "../../interfaces";

const Accordion = (props: AccordionProps) => {
  const { isMobile } = useIsMobile();
  const { isToggled, toggle } = useToggle(false);

  const noContent = props?.element?.props?.data?.length === 0;

  return (
    <div
      className="accordion"
      style={{
        width: isMobile ? "345.7px" : "",
      }}
    >
      <div
        className="accordion-header"
        style={{
          width: isMobile ? "345.7px" : "",
          margin: isMobile ? "0 0 0 40px" : "",
          padding: isMobile ? "0" : "",
        }}
      >
        <p
          className="accordion-name"
          style={{cursor:noContent?"default":"pointer"}}
          onClick={() => {
            if (!noContent) {
              toggle();
            }
          }}
        >
          {props.sectionName}
        </p>
        {!noContent && (
          <div
            className="Oval"
            style={{
              margin: isMobile ? "0 40px" : "",
            }}
            onClick={toggle}
          >
            <img
              className="accordion-icon"
              src={`${toIcons}/small-${isToggled ? "up" : "down"}.svg`}
            />
          </div>
        )}
      </div>
      {isToggled && props.element}
    </div>
  );
};
export default Accordion;
